import { useQuery } from "@tanstack/vue-query";
import { baseApi } from "../baseApi";
import { fetchAllWithCursor } from "../fetchWithCursor";
import {
  type ShopZoneLoadRequest,
  type ShopZoneLoadResponse,
  type ShopZoneWipeRequest,
  type ShopZoneWipeResponse,
  type ShopZoneListRequest,
  type ShopZoneListResponse,
} from "./types";

export const shopZoneWipeApi = (body: ShopZoneWipeRequest) =>
  baseApi<ShopZoneWipeResponse, ShopZoneWipeRequest>({ url: "/api/m/shop_zone/wipe", method: "POST", body });

export const shopZoneLoadApi = (body: ShopZoneLoadRequest) =>
  baseApi<ShopZoneLoadResponse, ShopZoneLoadRequest>({ url: "/api/m/shop_zone/load", method: "POST", body });

export const shopZoneListWithCursorApi = () => fetchAllWithCursor(shopZoneListApi, (r) => r.shop_zones);

export const shopZoneListApi = (body: ShopZoneListRequest = {}) =>
  baseApi<ShopZoneListResponse, ShopZoneListRequest>({ url: "/api/m/shop_zone/list", method: "POST", body });
const getShopZonApi = () =>
  baseApi<ShopZoneListResponse, Record<string, unknown>>({ url: "/api/m/shop_zone/list", method: "POST", body: {} });
export const useShopZoneList = () =>
  useQuery<ShopZoneListResponse, void>({
    queryKey: ["shop-zone-list"],
    queryFn: getShopZonApi,
  });
